import React from 'react';

interface ShuttersProps extends React.SVGProps<SVGSVGElement> {
  patternUrl: string;
}

export const Shutters76mmClearviewTiltControlRevealFit = ({
  patternUrl,
  ...props
}: ShuttersProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      id="prefix__Layer_1"
      data-name="Layer 1"
      viewBox="0 0 555.2 410"
      preserveAspectRatio="none"
      {...props}
    >
      <defs>
        <pattern
          id="shutters76"
          patternUnits="userSpaceOnUse"
          width="100"
          height="100"
        >
          <image href={patternUrl} x="0" y="0" width="100" height="100" />
        </pattern>
      </defs>
      <defs>
        <linearGradient
          id="prefix__linear-gradient"
          x1={41.41}
          y1={-87.31}
          x2={41.41}
          y2={-60.18}
          gradientTransform="matrix(1 0 0 -1 .5 -19.55)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.24} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.3} />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-2"
          x1={7382.81}
          y1={-87.31}
          x2={7382.81}
          y2={-60.18}
          gradientTransform="rotate(180 3819.795 -9.775)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-3"
          x1={41.41}
          y1={-114.76}
          x2={41.41}
          y2={-87.63}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-4"
          x1={7382.81}
          y1={-114.76}
          x2={7382.81}
          y2={-87.63}
          gradientTransform="rotate(180 3819.795 -9.775)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-5"
          x1={41.41}
          y1={-142.26}
          x2={41.41}
          y2={-115.14}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-6"
          x1={7382.81}
          y1={-142.26}
          x2={7382.81}
          y2={-115.14}
          gradientTransform="rotate(180 3819.795 -9.775)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-7"
          x1={41.41}
          y1={-169.77}
          x2={41.41}
          y2={-142.64}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-8"
          x1={7382.81}
          y1={-169.77}
          x2={7382.81}
          y2={-142.64}
          gradientTransform="rotate(180 3819.795 -9.775)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-9"
          x1={41.41}
          y1={-197.24}
          x2={41.41}
          y2={-170.11}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-10"
          x1={7382.81}
          y1={-197.24}
          x2={7382.81}
          y2={-170.11}
          gradientTransform="rotate(180 3819.795 -9.775)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-11"
          x1={41.41}
          y1={-224.73}
          x2={41.41}
          y2={-197.61}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-12"
          x1={7382.81}
          y1={-224.73}
          x2={7382.81}
          y2={-197.61}
          gradientTransform="rotate(180 3819.795 -9.775)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-13"
          x1={41.41}
          y1={-252.22}
          x2={41.41}
          y2={-225.11}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-14"
          x1={7382.81}
          y1={-252.22}
          x2={7382.81}
          y2={-225.11}
          gradientTransform="rotate(180 3819.795 -9.775)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-15"
          x1={41.41}
          y1={-279.69}
          x2={41.41}
          y2={-252.56}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-16"
          x1={7382.81}
          y1={-279.69}
          x2={7382.81}
          y2={-252.56}
          gradientTransform="rotate(180 3819.795 -9.775)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-17"
          x1={41.41}
          y1={-307.19}
          x2={41.41}
          y2={-280.06}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-18"
          x1={7382.81}
          y1={-307.19}
          x2={7382.81}
          y2={-280.06}
          gradientTransform="rotate(180 3819.795 -9.775)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-19"
          x1={41.41}
          y1={-334.69}
          x2={41.41}
          y2={-307.57}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-20"
          x1={7382.81}
          y1={-334.69}
          x2={7382.81}
          y2={-307.57}
          gradientTransform="rotate(180 3819.795 -9.775)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-21"
          x1={41.41}
          y1={-362.2}
          x2={41.41}
          y2={-335.07}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-22"
          x1={7382.81}
          y1={-362.2}
          x2={7382.81}
          y2={-335.07}
          gradientTransform="rotate(180 3819.795 -9.775)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-23"
          x1={41.41}
          y1={-389.7}
          x2={41.41}
          y2={-362.57}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-24"
          x1={7382.81}
          y1={-389.7}
          x2={7382.81}
          y2={-362.57}
          gradientTransform="rotate(180 3819.795 -9.775)"
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-25"
          x1={350.59}
          y1={-268.24}
          x2={350.59}
          y2={-263.61}
          gradientTransform="matrix(1 0 0 -1 .5 -19.55)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.37} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-26"
          x1={461.78}
          y1={-268.24}
          x2={461.78}
          y2={-263.61}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-27"
          x1={461.78}
          y1={-295.72}
          x2={461.78}
          y2={-291.1}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-28"
          x1={350.59}
          y1={-295.72}
          x2={350.59}
          y2={-291.1}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-29"
          x1={350.59}
          y1={-350.71}
          x2={350.59}
          y2={-346.08}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-30"
          x1={461.78}
          y1={-350.71}
          x2={461.78}
          y2={-346.08}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-31"
          x1={350.59}
          y1={-75.79}
          x2={350.59}
          y2={-71.16}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-32"
          x1={461.78}
          y1={-75.79}
          x2={461.78}
          y2={-71.16}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-33"
          x1={350.59}
          y1={-103.28}
          x2={350.59}
          y2={-98.66}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-34"
          x1={461.78}
          y1={-103.28}
          x2={461.78}
          y2={-98.66}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-35"
          x1={350.59}
          y1={-130.78}
          x2={350.59}
          y2={-126.15}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-36"
          x1={461.78}
          y1={-130.78}
          x2={461.78}
          y2={-126.15}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-37"
          x1={350.59}
          y1={-158.27}
          x2={350.59}
          y2={-153.64}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-38"
          x1={461.78}
          y1={-158.27}
          x2={461.78}
          y2={-153.64}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-39"
          x1={350.59}
          y1={-185.76}
          x2={350.59}
          y2={-181.13}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-40"
          x1={461.78}
          y1={-185.76}
          x2={461.78}
          y2={-181.13}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-41"
          x1={350.59}
          y1={-213.25}
          x2={350.59}
          y2={-208.62}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-42"
          x1={461.78}
          y1={-213.25}
          x2={461.78}
          y2={-208.62}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-43"
          x1={350.59}
          y1={-240.74}
          x2={350.59}
          y2={-236.11}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-44"
          x1={461.78}
          y1={-240.74}
          x2={461.78}
          y2={-236.11}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-45"
          x1={350.59}
          y1={-323.22}
          x2={350.59}
          y2={-318.59}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-46"
          x1={461.78}
          y1={-323.22}
          x2={461.78}
          y2={-318.59}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-47"
          x1={350.59}
          y1={-378.2}
          x2={350.59}
          y2={-373.57}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <linearGradient
          id="prefix__linear-gradient-48"
          x1={461.78}
          y1={-378.2}
          x2={461.78}
          y2={-373.57}
          xlinkHref="#prefix__linear-gradient-25"
        />
        <pattern
          id="prefix__SVGID_1_"
          data-name="SVGID 1"
          width={135}
          height={135}
          patternTransform="matrix(.96 0 0 -.94 555.94 -15744.1)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 135 135"
        >
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <use
            id="prefix__image"
            className="prefix__cls-2"
            transform="matrix(1 0 0 -1 0 135)"
            xlinkHref="#prefix__image-2"
          />
        </pattern>
        <pattern
          id="prefix__SVGID_1_3"
          data-name="SVGID 1 3"
          width={135}
          height={135}
          patternTransform="matrix(.96 0 0 -.96 521.03 -16038.36)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 135 135"
        >
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <use
            id="prefix__image-3"
            data-name="image"
            className="prefix__cls-2"
            transform="matrix(1 0 0 -1 0 135)"
            xlinkHref="#prefix__image-2"
          />
        </pattern>
        <pattern
          id="prefix__SVGID_1_5"
          data-name="SVGID 1 5"
          width={135}
          height={135}
          patternTransform="matrix(.96 0 0 -1.2 555.94 -20327.53)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 135 135"
        >
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <path className="prefix__cls-1" d="M0 0h135v135H0z" />
          <use
            id="prefix__image-4"
            data-name="image"
            className="prefix__cls-2"
            transform="matrix(1 0 0 -1 0 135)"
            xlinkHref="#prefix__image-2"
          />
        </pattern>
        <style>
          {
            '.prefix__cls-1,.prefix__cls-31,.prefix__cls-59{fill:none}.prefix__cls-2,.prefix__cls-31,.prefix__cls-59{isolation:isolate}.prefix__cls-31,.prefix__cls-4{opacity:.2}.prefix__cls-5{fill:#ececec;stroke:gray}.prefix__cls-31,.prefix__cls-5,.prefix__cls-59{stroke-miterlimit:10;stroke-width:.95px}.prefix__cls-31,.prefix__cls-59{stroke:#4d4d4d}.prefix__cls-59{opacity:.15}.prefix__cls-62{fill:gray;opacity:.2}'
          }
        </style>
        <image
          id="prefix__image-2"
          width={135}
          height={135}
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIcAAACHCAYAAAA850oKAAAACXBIWXMAAAsSAAALEgHS3X78AAABVElEQVR4Xu3SsRGAIADAQGT/9ajtXEMWIOcA/tcpcz33egcczK+A/zIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHyRwkc5DMQTIHaQMukgSnWXOGhgAAAABJRU5ErkJggg=="
        />
      </defs>
      <path
        d="M515.39 13.17H13.08v383.92h529.85V13.17zM298 40.17h106.2v11.49H298zm0 16.06h106.2v22.84H298zm0 27.5h106.2v22.81H298zm0 27.41h106.2V134H298zm0 27.5h106.2v22.91H298zm0 27.51h106.2v22.9H298zm0 27.5h106.2v22.9H298zm0 27.5h106.2v22.91H298zm0 27.51h106.2v22.9H298zm0 27.41h106.2V299H298zm0 27.5h106.2v22.9H298zm0 27.5h106.2V354H298zm217.41 39H298v-11.46h106.2v11.45h5v-11.45h106.19zm0-16.05H409.17V331.1h106.22zm0-27.51H409.17v-22.9h106.22zm0-27.5H409.17v-22.9h106.22zm0-27.41H409.17v-22.9h106.22zm0-27.5H409.17v-22.92h106.22zm0-27.51H409.17v-22.9h106.22zm0-27.5H409.17v-22.9h106.22zm0-27.5H409.17v-22.92h106.22zm0-27.51H409.17v-22.9h106.22zm0-27.5H409.17V83.76h106.22zm0-27.5H409.17V56.26h106.22zm0-27.41H409.17V40.2h106.22z"
        fill="url(#shutters76)"
      />
      <g className="prefix__cls-4">
        <path
          className="prefix__cls-5"
          d="M13.56 72.68h2.49v35.76h-2.49zM13.56 301.82h2.49v35.76h-2.49z"
        />
      </g>
      <g className="prefix__cls-4">
        <path
          className="prefix__cls-5"
          d="M540.44 72.68h2.49v35.76h-2.49zM540.44 301.82h2.49v35.76h-2.49z"
        />
      </g>
      <path
        fill="url(#prefix__linear-gradient)"
        d="M42.72 40.67h-1.63V67.8l1.63-27.13z"
      />
      <path
        fill="url(#prefix__linear-gradient-2)"
        d="M256.01 40.67h1.53V67.8l-1.53-27.13z"
      />
      <path
        fill="url(#prefix__linear-gradient-3)"
        d="M42.72 68.08h-1.63v27.13l1.63-27.13z"
      />
      <path
        fill="url(#prefix__linear-gradient-4)"
        d="M256.01 68.08h1.53v27.13l-1.53-27.13z"
      />
      <path
        fill="url(#prefix__linear-gradient-5)"
        d="M42.72 95.59h-1.63v27.12l1.63-27.12z"
      />
      <path
        fill="url(#prefix__linear-gradient-6)"
        d="M256.01 95.59h1.53v27.12l-1.53-27.12z"
      />
      <path
        fill="url(#prefix__linear-gradient-7)"
        d="M42.72 123.09h-1.63v27.13l1.63-27.13z"
      />
      <path
        fill="url(#prefix__linear-gradient-8)"
        d="M256.01 123.09h1.53v27.13l-1.53-27.13z"
      />
      <path
        fill="url(#prefix__linear-gradient-9)"
        d="M42.72 150.59h-1.63v27.13l1.63-27.13z"
      />
      <path
        fill="url(#prefix__linear-gradient-10)"
        d="M256.01 150.59h1.53v27.13l-1.53-27.13z"
      />
      <path
        fill="url(#prefix__linear-gradient-11)"
        d="M42.72 178.1h-1.63v27.12l1.63-27.12z"
      />
      <path
        fill="url(#prefix__linear-gradient-12)"
        d="M256.01 178.1h1.53v27.12l-1.53-27.12z"
      />
      <path
        fill="url(#prefix__linear-gradient-13)"
        d="M42.72 205.6h-1.63v27.03l1.63-27.03z"
      />
      <path
        fill="url(#prefix__linear-gradient-14)"
        d="M256.01 205.6h1.53v27.03l-1.53-27.03z"
      />
      <path
        fill="url(#prefix__linear-gradient-15)"
        d="M42.72 233.01h-1.63v27.13l1.63-27.13z"
      />
      <path
        fill="url(#prefix__linear-gradient-16)"
        d="M256.01 233.01h1.53v27.13l-1.53-27.13z"
      />
      <path
        fill="url(#prefix__linear-gradient-17)"
        d="M42.72 260.51h-1.63v27.13l1.63-27.13z"
      />
      <path
        fill="url(#prefix__linear-gradient-18)"
        d="M256.01 260.51h1.53v27.13l-1.53-27.13z"
      />
      <path
        fill="url(#prefix__linear-gradient-19)"
        d="M42.72 288.02h-1.63v27.12l1.63-27.12z"
      />
      <path
        fill="url(#prefix__linear-gradient-20)"
        d="M256.01 288.02h1.53v27.12l-1.53-27.12z"
      />
      <path
        fill="url(#prefix__linear-gradient-21)"
        d="M42.72 315.52h-1.63v27.13l1.63-27.13z"
      />
      <path
        fill="url(#prefix__linear-gradient-22)"
        d="M256.01 315.52h1.53v27.13l-1.53-27.13z"
      />
      <path
        fill="url(#prefix__linear-gradient-23)"
        d="M42.72 343.02h-1.63v27.13l1.63-27.13z"
      />
      <path
        fill="url(#prefix__linear-gradient-24)"
        d="M256.01 343.02h1.53v27.13l-1.53-27.13z"
      />
      <g opacity={0.54}>
        <path
          className="prefix__cls-31"
          d="M404.2 40.2h4.97v329.86h-4.97zM146.83 40.2h4.97v329.86h-4.97z"
        />
        <path
          fill="url(#prefix__linear-gradient-25)"
          d="M297.98 244.09H404.2v4.6H297.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-26)"
          d="M409.17 244.09h106.22v4.6H409.17z"
        />
        <path
          fill="url(#prefix__linear-gradient-27)"
          d="M409.17 271.59h106.22v4.6H409.17z"
        />
        <path
          fill="url(#prefix__linear-gradient-28)"
          d="M297.98 271.59H404.2v4.6H297.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-29)"
          d="M297.98 326.5H404.2v4.6H297.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-30)"
          d="M409.17 326.5h106.22v4.6H409.17z"
        />
        <path
          fill="url(#prefix__linear-gradient-31)"
          d="M297.98 51.66H404.2v4.6H297.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-32)"
          d="M409.17 51.66h106.22v4.6H409.17z"
        />
        <path
          fill="url(#prefix__linear-gradient-33)"
          d="M297.98 79.07H404.2v4.6H297.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-34)"
          d="M409.17 79.07h106.22v4.6H409.17z"
        />
        <path
          fill="url(#prefix__linear-gradient-35)"
          d="M297.98 106.57H404.2v4.6H297.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-36)"
          d="M409.17 106.57h106.22v4.6H409.17z"
        />
        <path
          fill="url(#prefix__linear-gradient-37)"
          d="M297.98 134.07H404.2v4.6H297.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-38)"
          d="M409.17 134.07h106.22v4.6H409.17z"
        />
        <path
          fill="url(#prefix__linear-gradient-39)"
          d="M297.98 161.58H404.2v4.6H297.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-40)"
          d="M409.17 161.58h106.22v4.6H409.17z"
        />
        <path
          fill="url(#prefix__linear-gradient-41)"
          d="M297.98 189.08H404.2v4.6H297.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-42)"
          d="M409.17 189.08h106.22v4.6H409.17z"
        />
        <path
          fill="url(#prefix__linear-gradient-43)"
          d="M297.98 216.58H404.2v4.6H297.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-44)"
          d="M409.17 216.58h106.22v4.6H409.17z"
        />
        <path
          fill="url(#prefix__linear-gradient-45)"
          d="M297.98 299H404.2v4.6H297.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-46)"
          d="M409.17 299h106.22v4.6H409.17z"
        />
        <path
          fill="url(#prefix__linear-gradient-47)"
          d="M297.98 354.01H404.2v4.6H297.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-48)"
          d="M409.17 354.01h106.22v4.6H409.17z"
        />
      </g>
      <path
        className="prefix__cls-31"
        d="M514.91 12.7H297.5v.09h-39.1v-.09H12.6v384.86h245.9v-.11h39.1v.09h245.9V12.7zM40.13 396.62H13.56v-383h26.57zm1-383H257.5v26.11H41.09zm216.37 383H41.09v-26.09H257.5v26.09zm0-329.38H151.8v.84h105.7v26.66H151.8v.85h105.7v26.65H151.8v.85h105.7v26.66H151.8v.84h105.7v26.66H151.8v.85h105.7v26.56H151.8v.85h105.7v26.66H151.8v.83h105.7v26.66H151.8v.84h105.7v26.66H151.8v.84h105.7v26.66H151.8v.84h105.7v26.66H151.8v.84h105.7v26.57H151.8v.47h-5v-.47H41.09V343h105.74v-.84H41.09v-26.64h105.74v-.84H41.09V288h105.74v-.85H41.09v-26.64h105.74v-.84H41.09V233h105.74v-.84H41.09V205.6h105.74v-.94H41.09V178h105.74v-.84H41.09V150.5h105.74v-.85H41.09V123h105.74v-.85H41.09V95.59h105.74v-.85H41.09V68.08h105.74v-.84H41.09V40.67h105.74v-.47h5v.47H257.5zm20.08 329.48H258.5V13.54h19.12zm20-345.53l-.08 5.53h.09v22h-.09v5.54h.09v21.87h-.09v5.54h.09v22h-.09v5.54h.09v22h-.09v5.53h.09v22h-.09v5.54h.09v22h-.09v5.54h.09v22h-.09v5.54h.09v22h-.09v5.54h.09v21.87h-.09v5.54h.09v22h-.09v5.54h.09v22h-.09v5.54h.09v10.51h-.09V397h-19.12V13.54h19.12v27.13h.09zm217.33 345.43H298.5v-26.09h216.41zm0-345.43H409.17v.93h105.74v3.67H409.17v.93h105.74v22H409.17v.94h105.74v3.66H409.17v.94h105.74v21.87H409.17v.94h105.74v3.66H409.17v.94h105.74v22H409.17v.94h105.74v3.66H409.17v.94h105.74v22H409.17v.94h105.74v3.66H409.17v.93h105.74v22H409.17v.94h105.74v3.66H409.17v.94h105.74v22H409.17v.94h105.74v3.66H409.17v.94h105.74v22H409.17v.94h105.74v3.66H409.17v.94h105.74v22H409.17v.94h105.74v3.7H409.17v.94h105.74v21.87H409.17v.68h105.74v3.66H409.17v.94h105.74v22H409.17v.91h105.74v3.66H409.17v.94h105.74v22H409.17v.86h105.74v3.66H409.17v.94h105.74v10.51H409.17v.43h-5v-.47h-105.8v-10.45H404.2v-.94H298.5v-3.69h105.7v-.94H298.37v-22H404.2v-.94H298.5v-3.66h105.7V326H298.37v-21.84H404.2v-.94H298.5v-3.77h105.7v-.94H298.37v-22H404.2v-.94H298.5v-3.66h105.7V271H298.37v-22H404.2v-1H298.5v-3.58h105.7v-.94H298.37v-22H404.2v-.94H298.5v-3.66h105.7V216H298.37v-22H404.2v-1H298.5v-3.59h105.7v-.94H298.37v-22H404.2v-.94H298.5V162h105.7v-1H298.37v-22H404.2v-.94H298.5v-3.62h105.7v-.94H298.37v-21.77H404.2v-.94H298.5V107h105.7v-.94H298.37V84.23H404.2v-.94H298.5v-3.66h105.7v-.94H298.37v-22H404.2v-.93H298.5v-3.64h105.7v-.93H298.37V40.67H404.2v-.47h5v.47h105.71zm0-11.46H298.5V13.64h216.41zm27.59 356.89h-26.63v-383h26.63zM404.2 40.2v329.86h5V40.2zM146.83 370.06h5V40.2h-5z"
      />
      <path
        style={{
          isolation: 'isolate',
        }}
        stroke="#4d4d4d"
        strokeMiterlimit={10}
        opacity={0.2}
        fill="none"
        d="M.5.5h555.2v409.9H.5z"
      />
      <path
        d="M.5.5v410h555.2V.5zm542 396.6H13.7V13.7h528.8z"
        fill="url(#shutters76)"
      />
      <path
        d="M554.7 1.5v408H1.5V1.5h553.2M12.8 398.1h530.7V12.7H12.8v385.4M555.7.5H.5v410h555.2zM13.8 397.1V13.7h528.7v383.4z"
        fill="#4d4d4d"
      />
      <path
        className="prefix__cls-59"
        d="M406.68 31.45a4.29 4.29 0 014.32 4.29V40h-8.6v-4.29a4.29 4.29 0 014.29-4.26z"
      />
      <path fill="url(#prefix__SVGID_1_3)" d="M404.67 38.89h4.03v1.81h-4.03z" />
      <path
        className="prefix__cls-59"
        d="M409.29 39.78v-3.06h-5.08v3.06M149.3 32.08a4.29 4.29 0 014.29 4.29v4.29H145v-4.29a4.29 4.29 0 014.29-4.29z"
      />
      <path fill="url(#prefix__SVGID_1_5)" d="M147.31 39.05h4.01v2.28h-4.01z" />
      <path className="prefix__cls-59" d="M151.91 40.44v-3.06h-5.08v3.06" />
      <path
        className="prefix__cls-62"
        d="M551.34 4.83l3.37-3.39v407.99l-3.37-3.36V4.83zM4.88 4.83L1.51 1.44v407.99l3.37-3.36V4.83zM4.87 406.09l-3.38 3.37h553.22l-3.36-3.37H4.87z"
      />
      <path
        className="prefix__cls-62"
        d="M4.87 4.81L1.49 1.44h553.22l-3.36 3.37H4.87z"
      />
    </svg>
  );
};
